module.exports = __webpack_public_path__ + "static/img/jsz.82d330d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jsz.png
// module id = 9OEu
// module chunks = 0